<p>The study, now in its 31st year, measures the number of problems per 100 vehicles (PP100) experienced during the past 12 months by original owners of their three-year-old vehicles.</p>
